import { useSelector } from "react-redux";

export const UserAccessCustomState = (AllowAccessId) => {
  const accessRights = useSelector((state) => state.UserAccessData);

  // If access data is missing, allow access by default
  if (!accessRights || !accessRights?.length > 0) return true;

  // Otherwise, check if buttonValue exists in access rights
  const accessibleButtons = accessRights.some((right) => right.Access_Control_Id === AllowAccessId)
  return accessibleButtons;
};

export const UserAccessCustomState_Inverse = (AllowAccessId) => {
  debugger;
  const accessRights = useSelector((state) => state.UserAccessData);

  // If access data is missing, allow access by default
  if (!accessRights || !accessRights?.length > 0) return false;

  // Otherwise, check if buttonValue exists in access rights
  const accessibleButtons = accessRights.some((right) => right.Access_Control_Id === AllowAccessId)
  return accessibleButtons;
};